// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { getParam, getSite, getSiteLotteriesByLotteryIdWinners, getSiteTestSideEventProgressByProgressByUid, getUserLotteriesWins, getUserMe, getUserMissionLogs, getUserRewards, getUserState, type Options, postUserClaimAccumulateSpin, postUserClaimItemByItemId, postUserSpin, postUserUpdateMission } from '../sdk.gen';
import type { GetParamData, GetParamResponse, GetSiteData, GetSiteLotteriesByLotteryIdWinnersData, GetSiteLotteriesByLotteryIdWinnersResponse, GetSiteResponse, GetSiteTestSideEventProgressByProgressByUidData, GetUserLotteriesWinsData, GetUserLotteriesWinsResponse, GetUserMeData, GetUserMeResponse, GetUserMissionLogsData, GetUserMissionLogsResponse, GetUserRewardsData, GetUserRewardsResponse, GetUserStateData, GetUserStateResponse, PostUserClaimAccumulateSpinData, PostUserClaimAccumulateSpinResponse, PostUserClaimItemByItemIdData, PostUserClaimItemByItemIdResponse, PostUserSpinData, PostUserSpinResponse, PostUserUpdateMissionData, PostUserUpdateMissionResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const getParamQueryKey = (options: Options<GetParamData>) => createQueryKey('getParam', options);

/**
 * Common params
 */
export const getParamOptions = (options: Options<GetParamData>) => queryOptions<GetParamResponse, DefaultError, GetParamResponse, ReturnType<typeof getParamQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getParam({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getParamQueryKey(options)
});

export const getSiteQueryKey = (options?: Options<GetSiteData>) => createQueryKey('getSite', options);

export const getSiteOptions = (options?: Options<GetSiteData>) => queryOptions<GetSiteResponse, DefaultError, GetSiteResponse, ReturnType<typeof getSiteQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSite({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSiteQueryKey(options)
});

export const getSiteLotteriesByLotteryIdWinnersQueryKey = (options: Options<GetSiteLotteriesByLotteryIdWinnersData>) => createQueryKey('getSiteLotteriesByLotteryIdWinners', options);

/**
 * Get list of daily lottery winners of a lottery
 */
export const getSiteLotteriesByLotteryIdWinnersOptions = (options: Options<GetSiteLotteriesByLotteryIdWinnersData>) => queryOptions<GetSiteLotteriesByLotteryIdWinnersResponse, DefaultError, GetSiteLotteriesByLotteryIdWinnersResponse, ReturnType<typeof getSiteLotteriesByLotteryIdWinnersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSiteLotteriesByLotteryIdWinners({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSiteLotteriesByLotteryIdWinnersQueryKey(options)
});

export const getSiteTestSideEventProgressByProgressByUidQueryKey = (options: Options<GetSiteTestSideEventProgressByProgressByUidData>) => createQueryKey('getSiteTestSideEventProgressByProgressByUid', options);

export const getSiteTestSideEventProgressByProgressByUidOptions = (options: Options<GetSiteTestSideEventProgressByProgressByUidData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof getSiteTestSideEventProgressByProgressByUidQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSiteTestSideEventProgressByProgressByUid({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSiteTestSideEventProgressByProgressByUidQueryKey(options)
});

export const getUserMeQueryKey = (options?: Options<GetUserMeData>) => createQueryKey('getUserMe', options);

/**
 * Get user session
 */
export const getUserMeOptions = (options?: Options<GetUserMeData>) => queryOptions<GetUserMeResponse, DefaultError, GetUserMeResponse, ReturnType<typeof getUserMeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserMeQueryKey(options)
});

export const getUserStateQueryKey = (options?: Options<GetUserStateData>) => createQueryKey('getUserState', options);

/**
 * Get user state
 */
export const getUserStateOptions = (options?: Options<GetUserStateData>) => queryOptions<GetUserStateResponse, DefaultError, GetUserStateResponse, ReturnType<typeof getUserStateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserState({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserStateQueryKey(options)
});

/**
 * Update user mission progress
 */
export const postUserUpdateMissionMutation = (options?: Partial<Options<PostUserUpdateMissionData>>): UseMutationOptions<PostUserUpdateMissionResponse, DefaultError, Options<PostUserUpdateMissionData>> => {
    const mutationOptions: UseMutationOptions<PostUserUpdateMissionResponse, DefaultError, Options<PostUserUpdateMissionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postUserUpdateMission({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Spin and return new user state and receive items. Accumulate items will be automatically claimed
 */
export const postUserSpinMutation = (options?: Partial<Options<PostUserSpinData>>): UseMutationOptions<PostUserSpinResponse, DefaultError, Options<PostUserSpinData>> => {
    const mutationOptions: UseMutationOptions<PostUserSpinResponse, DefaultError, Options<PostUserSpinData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postUserSpin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Claim random accumulate rewards.
 */
export const postUserClaimAccumulateSpinMutation = (options?: Partial<Options<PostUserClaimAccumulateSpinData>>): UseMutationOptions<PostUserClaimAccumulateSpinResponse, DefaultError, Options<PostUserClaimAccumulateSpinData>> => {
    const mutationOptions: UseMutationOptions<PostUserClaimAccumulateSpinResponse, DefaultError, Options<PostUserClaimAccumulateSpinData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postUserClaimAccumulateSpin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Claim item by itemId
 */
export const postUserClaimItemByItemIdMutation = (options?: Partial<Options<PostUserClaimItemByItemIdData>>): UseMutationOptions<PostUserClaimItemByItemIdResponse, DefaultError, Options<PostUserClaimItemByItemIdData>> => {
    const mutationOptions: UseMutationOptions<PostUserClaimItemByItemIdResponse, DefaultError, Options<PostUserClaimItemByItemIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postUserClaimItemByItemId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUserLotteriesWinsQueryKey = (options?: Options<GetUserLotteriesWinsData>) => createQueryKey('getUserLotteriesWins', options);

/**
 * Get list of user lottery wins
 */
export const getUserLotteriesWinsOptions = (options?: Options<GetUserLotteriesWinsData>) => queryOptions<GetUserLotteriesWinsResponse, DefaultError, GetUserLotteriesWinsResponse, ReturnType<typeof getUserLotteriesWinsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserLotteriesWins({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserLotteriesWinsQueryKey(options)
});

export const getUserMissionLogsQueryKey = (options?: Options<GetUserMissionLogsData>) => createQueryKey('getUserMissionLogs', options);

export const getUserMissionLogsOptions = (options?: Options<GetUserMissionLogsData>) => queryOptions<GetUserMissionLogsResponse, DefaultError, GetUserMissionLogsResponse, ReturnType<typeof getUserMissionLogsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserMissionLogs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserMissionLogsQueryKey(options)
});

export const getUserRewardsQueryKey = (options?: Options<GetUserRewardsData>) => createQueryKey('getUserRewards', options);

/**
 * List user rewards history. Filter by "source" if specified.
 */
export const getUserRewardsOptions = (options?: Options<GetUserRewardsData>) => queryOptions<GetUserRewardsResponse, DefaultError, GetUserRewardsResponse, ReturnType<typeof getUserRewardsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserRewards({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserRewardsQueryKey(options)
});
